import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Policies.css';

function KVKK() {
  return (
    <Container className="policy-page py-5">
      <h1 className="text-center mb-5">KVKK Aydınlatma Metni</h1>
      
      <Row className="g-4">
        <Col lg={8} className="mx-auto">
          <Card className="policy-card">
            <Card.Body>
              <section className="mb-5">
                <h4>Veri Sorumlusu</h4>
                <p>
                  6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, Mr. Brown olarak, veri sorumlusu sıfatıyla, kişisel verilerinizi aşağıda açıklanan amaçlar kapsamında hukuka ve dürüstlük kurallarına uygun bir şekilde işleyebilecek, kaydedebilecek, saklayabilecek, sınıflandırabilecek, güncelleyebilecek ve mevzuatın izin verdiği hallerde üçüncü kişilere açıklayabilecek/aktarabilecektir.
                </p>
              </section>

              <section className="mb-5">
                <h4>Kişisel Verilerin İşlenme Amacı</h4>
                <p>Kişisel verileriniz aşağıdaki amaçlar doğrultusunda işlenmektedir:</p>
                <ul className="policy-list">
                  <li>Ürün ve hizmetlerimizin sunulması</li>
                  <li>Müşteri ilişkilerinin yönetimi</li>
                  <li>Sipariş takibi ve teslimatı</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>Müşteri memnuniyetinin sağlanması</li>
                  <li>İletişim faaliyetlerinin yürütülmesi</li>
                  <li>Pazarlama analiz çalışmalarının yürütülmesi</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>Kişisel Verilerin Aktarılması</h4>
                <p>
                  Kişisel verileriniz, yukarıda belirtilen amaçlar doğrultusunda, iş ortaklarımıza, tedarikçilerimize, kanunen yetkili kamu kurumlarına ve yetkili özel kişilere KVKK'nın 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde aktarılabilecektir.
                </p>
              </section>

              <section className="mb-5">
                <h4>Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi</h4>
                <p>
                  Kişisel verileriniz, internet sitemiz, mobil uygulamamız, e-posta, telefon, çağrı merkezi ve diğer yazılı veya sözlü iletişim kanalları aracılığıyla elektronik ve/veya fiziki ortamda toplanmaktadır. Bu kapsamda; kimlik, iletişim, müşteri işlem, pazarlama ve diğer kişisel verileriniz işlenmektedir.
                </p>
              </section>

              <section>
                <h4>Haklarınız</h4>
                <p>KVKK'nın 11. maddesi uyarınca sahip olduğunuz haklar:</p>
                <ul className="policy-list">
                  <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                  <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                  <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                  <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
                  <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                  <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
                  <li>Kişisel verilerinizin aktarıldığı üçüncü kişilere yukarıda sayılan işlemlerin bildirilmesini isteme</li>
                </ul>
                <p className="mt-4">
                  Haklarınıza ilişkin taleplerinizi mr.browncases@gmail.com adresine iletebilirsiniz. Talebiniz en geç 30 gün içinde ücretsiz olarak sonuçlandırılacaktır.
                </p>
              </section>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default KVKK; 